import maNavbarCategory from '@/components/navbarCategories'
import maForm from '@/components/mobilierForm'
import maAddDamages from '@/components/button-blue'
import maNotificationsTop from '@/components/notifications-top'
import maInputFile from '@/components/input/modules/fileImg'
import maModal from '@/components/modal'
import maInputTxt from '@/components/input/modules/text'
import maDatePicker from '@/components/datePicker'
import moment from 'moment'
import maButtonPhone from '@/components/buttonPhone'
import maEventBus from '@/components/eventbus/index.js'
import maNavbarStepper from '@/components/navbarStepper'
import debounce from '@/utils/debounce'
import { mapState, mapMutations, mapActions } from 'vuex'
import { apiGetForm } from '@/modules/Damage/services/menus'
import {
  apiPatchDamage,
  apiPostDamageUptec
} from '@/modules/Damage/services/damages'
import {
  WARRANTY_MODULE_NAME,
  WARRANTY_GET_FORMS,
  WARRANTY_CLEAR_REPORT,
  WARRANTY_UPDATE_REPORT,
  WARRANTY_UPDATE_CATEGORIES_QTY,
  WARRANTY_UPDATE_CATEGORIES_MOBILIER,
  WARRANTY_CLEAR_FORMS,
  WARRANTY_UPDATE_LITERALS_MOBILIER,
  WARRANTY_UPDATE_TEXT_SEARCH_MOBILIER,
  WARRANTY_UPDATE_CATEG_FINAL_LEVEL,
  WARRANTY_UPDATE_LAST_SELECTED_PROPERTIES,
  WARRANTY_GET_SINISTER,
  WARRANTY_UPDATE_DAMAGED_ITEM_KEY,
  WARRANTY_GET_FINAL_LEVEL,
  WARRANTY_UPDATE_OBJ_UPTEC,
  WARRANTY_UPDATE_DAMAGED_PART_KEY
} from '@/store/types'
import {
  FEATURE,
  CPI,
  FORM_INPUTS_MOBILIER,
  FORM_UPTEC_FEATURE,
  FORM_UPTEC_CPI
} from '@/constants'
import flowMixin from '@/modules/Flow/mixins/flowMixin'
import { prepareErrorForSentry } from '@/utils/errorHandling'

export default {
  name: 'damageMobilierCategory1',

  mixins: [flowMixin],

  data: function () {
    return {
      formData: [],
      titleCategory: '',
      damage: {
        asset_damages: 0
      },
      activeInput: '',
      activeInputValue: '',
      addDamageBtnIsHidden: false,
      levels: {},
      formTemplate: null,
      formKey: 0,
      warrantySubtypeId: null,
      imgListEnsemble: [],
      imgListPres: [],
      objectKeys: [],
      error: false,
      errorMsg: '',
      formType: '',
      poductIdGroup: null,
      inputValPrice: null,
      inputValDate: '',
      errorDate: false,
      errorPrice: false,
      loading: false,
      isDisabledBtn: null
    }
  },

  components: {
    maNavbarCategory,
    maForm,
    maAddDamages,
    maNotificationsTop,
    maInputFile,
    maModal,
    maInputTxt,
    maDatePicker,
    maButtonPhone,
    maNavbarStepper
  },

  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantySinisterId: 'sinisterId',
      stateWarrantyForms: 'forms',
      stateWarrantyCategoriesMobilier: 'categoriesMobilier',
      stateWarrantyCategoriesQty: 'categoriesQty',
      stateWarrantyDamagedItem: 'damagedItem',
      stateWarrantySecondaryId: 'secondaryId',
      stateWarrantyAddress: 'address',
      stateWarrantyZipCode: 'zipCode',
      stateWarrantyCoordinates: 'coordinates',
      stateWarrantyMoreThanTwoYears: 'moreThanTwoYears',
      stateWarrantyResidentType: 'residentType',
      stateWarrantyaddress: 'address',
      stateWarrantyLiteralsMobilier: 'literalsMobilier',
      stateWarrantyCategoryFinalLevel: 'categoryFinalLevel',
      stateWarrantySubtypeId: 'subtypeId',
      stateWarrantyDamagedItemKey: 'damagedItemKey',
      stateWarrantyDamagedPartKey: 'damagedPartKey'
    }),
    getBtnType() {
      return this.loading ? 'spinnerBtn' : 'functionalBtn'
    },
    showDateWithCorrectForm() {
      let date = moment(this.inputValDate, 'YYYY-MM-DD')
      let newFormat = date.format('DD-MM-YYYY')
      return newFormat
    }
  },

  methods: {
    ...mapMutations(WARRANTY_MODULE_NAME, {
      mutWarrantyClearReport: WARRANTY_CLEAR_REPORT,
      mutWarrantyClearForms: WARRANTY_CLEAR_FORMS,
      mutWarrantyUpdateReport: WARRANTY_UPDATE_REPORT,
      mutWarrantyUpdateCategoriesQty: WARRANTY_UPDATE_CATEGORIES_QTY,
      mutWarrantyUpdateCategoriesMobilier: WARRANTY_UPDATE_CATEGORIES_MOBILIER,
      mutWarrantyUpdateLiteralsMobilier: WARRANTY_UPDATE_LITERALS_MOBILIER,
      mutWarrantyUpdateTextSearchMobilier: WARRANTY_UPDATE_TEXT_SEARCH_MOBILIER,
      mutWarrantyUpdateCategFinalLevel: WARRANTY_UPDATE_CATEG_FINAL_LEVEL,
      mutWarrantyUpdateLastSelectedProperties:
        WARRANTY_UPDATE_LAST_SELECTED_PROPERTIES,
      mutWarrantyUpdateDamagedItemKey: WARRANTY_UPDATE_DAMAGED_ITEM_KEY,
      mutWarrantyUpdateObjUptec: WARRANTY_UPDATE_OBJ_UPTEC,
      mutWarrantyUpdateDamagedPartKey: WARRANTY_UPDATE_DAMAGED_PART_KEY
    }),
    ...mapActions(WARRANTY_MODULE_NAME, {
      actWarrantyGetForms: WARRANTY_GET_FORMS,
      actWarrantyGetSinister: WARRANTY_GET_SINISTER,
      actWarrantyGetFinalLevel: WARRANTY_GET_FINAL_LEVEL
    }),

    /**
     * Checks if there is inputValDate and sets the errorDate prop to true of false
     */
    checkInputDateValue() {
      if (this.inputValDate) {
        this.errorDate = false
      } else {
        this.errorDate = true
      }
    },

    /**
     * Checks if the format of the price is correct and if not it sets it to the correct format
     */
    checkInputPriceFormat(valuePrice) {
      const priceIntegr = parseInt(valuePrice)
      if (isNaN(priceIntegr)) {
        this.errorPrice = true
      } else {
        this.errorPrice = false
        this.inputValPrice = Math.trunc(priceIntegr)
      }
    },

    /**
     * Cheks if there is input date value and if there is no errorDate of errorPrice it will open the confirmation modal
     */
    handleOpenModal() {
      this.checkInputDateValue()
      if (!this.errorDate && !this.errorPrice) {
        this.$refs.modalConfirmation.showModal = true
      }
    },

    closeModaConfirmation() {
      this.$refs.modalConfirmation.showModal = false
    },

    /**
     * Sets the inputValDate with the value of the data picker only that formated
     */
    handleChangeInputDate(value) {
      this.inputValDate = moment(value).format('YYYY-MM-DD')
    },

    /**
     * When a category of the first level list of a category is clicked it updates the damaged key, the last selected properties, the categories mobilier object, the literals and checks if this category is final level category or not, and goes to next route
     */
    handleClickCategory(key, value, id, literal) {
      window.removeEventListener('popstate', this.handleBackButtonClick)
      this.mutWarrantyUpdateDamagedPartKey(literal)
      this.objectKeys = { ...this.stateWarrantyCategoriesMobilier }
      let category = 'cat1'
      this.mutWarrantyUpdateLastSelectedProperties({ key, category })

      let reportObj = this.stateWarrantyCategoriesMobilier
      reportObj[key] = value
      category = 'cat2'
      this.mutWarrantyClearForms()
      const warrantyId = this.getWarrantyId
      const report = reportObj
      this.mutWarrantyUpdateLiteralsMobilier({ category, literal })
      this.actWarrantyGetForms({ report, warrantyId }).then((resp) => {
        if (resp.formsUpdated) {
          if (Object.keys(this.levels).length === 2) {
            this.mutWarrantyUpdateCategFinalLevel(true)
            this.mutWarrantyUpdateCategoriesMobilier(reportObj)
            this.mutWarrantyUpdateDamagedItemKey(key)
            this.mutWarrantyUpdateCategoriesQty(0)
            this.checkIfUptecFeature()
          } else {
            const level2 = this.idFilteredForm(this.stateWarrantyForms[0])
            this.levels = { ...this.levels, level2 }
            this.actWarrantyGetFinalLevel(this.levels).then(() => {
              this.mutWarrantyUpdateCategoriesMobilier(reportObj)
              this.mutWarrantyUpdateDamagedItemKey(key)
              this.mutWarrantyUpdateCategoriesQty(0)
              this.checkIfUptecFeature()
            })
          }
        }
      }).catch((error) => {
        const context = {
          component: 'damageMobilierCategory1',
          method: 'handleClickCategory.actWarrantyGetForms',
          route: this.$route.path
        }

        const tags = prepareErrorForSentry(error, context)

        this.sendSentryError(
          `Error getting final level: ${error.message || 'Unknown error'}`,
          error.response && error.response.status >= 500 ? 'error' : 'warning',
          tags,
          this.getWarrantyId,
          'handleClickCategory.actWarrantyGetFinalLevel'
        )
      })
    },

    goToSearchMobilierUptec(productIdGroup) {
      const damageMobilierUptecFeatureViewName = 'damageMobilierUptecFeature'
      const propertyType = this.getPropertyType
      const damageType = this.getDamageType
      const productId = productIdGroup
      this.goToView(damageMobilierUptecFeatureViewName, {
        propertyType,
        damageType,
        productId
      })
    },

    checkIfUptecFeature() {
      let idFeatureUptec = null
      this.mutWarrantyClearForms()
      let report = this.stateWarrantyCategoriesMobilier
      const warrantyId = this.getWarrantyId
      this.actWarrantyGetForms({ report, warrantyId }).then((res) => {
        if (res.formsUpdated) {
          this.stateWarrantyForms[0].form.regions[0].inputs.forEach((input) => {
            if (input.name === this.stateWarrantyDamagedItemKey) {
              input.options.forEach((option) => {
                if (
                  option.literal === this.stateWarrantyDamagedPartKey &&
                  option.is_upptec_damage &&
                  option.upptec_damage_type === FEATURE
                ) {
                  idFeatureUptec = option.upptec_product_group_id
                }
              })
            }
          })
          if (idFeatureUptec) {
            this.goToSearchMobilierUptec(idFeatureUptec)
          } else {
            this.goToNextRoute()
          }
        }
      }).catch((error) => {
        const context = {
          component: 'damageMobilierCategory1',
          method: 'checkIfUptecFeature',
          route: this.$route.path
        }

        const tags = prepareErrorForSentry(error, context)

        this.sendSentryError(
          `Error checking Uptec feature: ${error.message || 'Unknown error'}`,
          error.response && error.response.status >= 500 ? 'error' : 'warning',
          tags,
          this.getWarrantyId,
          'checkIfUptecFeature'
        )
      })
    },
    /**
     * Filter the form, removing the category selected before and returns the id
     */
    idFilteredForm(form) {
      let id = {}
      Object.keys(this.objectKeys).forEach((key) => {
        form.form.regions[0].inputs = form.form.regions[0].inputs.filter(
          (input) => {
            return input.name !== key
          }
        )
      })

      form.form.regions[0].inputs = form.form.regions[0].inputs.filter(
        (input) => {
          return input.type !== 'hidden'
        }
      )
      id = form.form.regions[0].inputs[0].id

      return id
    },

    goToNextRoute() {
      const damageMobilierCategory2ViewName = 'damageMobilierCategory2'
      const propertyType = this.getPropertyType
      const damageType = this.getDamageType
      this.goToView(damageMobilierCategory2ViewName, {
        propertyType,
        damageType
      })
    },

    /**
     * Filters the image arrays, deletes the imgSrc key
     */
    filterImageSrc() {
      /* this.imgListEnsemble.forEach((image) => {
        delete image.imgSrc
      }) */
      this.imgListPres.forEach((image) => {
        delete image.imgSrc
      })
    },

    async handleEnableButton() {
      let imgList = []
      imgList = [...imgList, ...this.imgListEnsemble, ...this.imgListPres]
      const imagesValidated = await this.checkImages(imgList)
      if (imagesValidated) {
        this.isDisabledBtn = false
      } else {
        this.isDisabledBtn = true
      }
    },

    checkImages(imgList) {
      if (!this.addDamagesHasImages) return true

      if (emptyImgList[0] === '0' || emptyImgList[0] === '1') {
        return true
      } else {
        const imageTypes = ['inputImgPres']
        const imageListTypes = [
          ...new Set(imgList.map((image) => image.imageType))
        ]

        return imageTypes.every(
          (imageType) => imageListTypes.indexOf(imageType) > -1
        )
      }
    },

    /**
     * Adds the damages
     */
    async handleAddDamages() {
      this.loading = true
      let imgList = []
      this.filterImageSrc()
      this.getSubwarrantyId()
      imgList = [...imgList /* ...this.imgListEnsemble */, ...this.imgListPres]

      const imagesValidated = await this.checkImages(imgList)
      if (imagesValidated) {
        this.updateForm().then(() => {
          this.damage['asset_damages'] = this.formData.form.asset_damages
          let damageBody = {
            sinister_id: this.getSinisterId,
            event_id: this.stateWarrantySecondaryId,
            category: this.getWarrantyId,
            subcategory: this.stateWarrantySubtypeId || this.warrantySubtypeId,
            form_info: { ...this.damage },
            images: imgList
          }

          const postBody = {
            lat: this.stateWarrantyCoordinates.lat,
            lon: this.stateWarrantyCoordinates.lng,
            zip_code: this.stateWarrantyZipCode,
            real_estate: this.getPropertyType,
            declarant: this.stateWarrantyResidentType,
            more_than_two_years: this.stateWarrantyMoreThanTwoYears,
            address: this.stateWarrantyAddress
          }

          damageBody = {
            ...damageBody,
            ...postBody
          }

          // 400 campos faltan, 500 generico
          apiPatchDamage(damageBody)
            .then(() => {
              this.mutWarrantyClearForms()
              this.mutWarrantyClearReport()
              const damagesViewViewName = 'damages-view'
              this.goToView(damagesViewViewName)
            })
            .catch((error) => {
              this.loading = false
              this.error = true
              this.errorMsg = this.$t(
                `notifications.error.${error.response.status}.title`
              )

              const context = {
                component: 'damageMobilierCategory1',
                method: 'handleAddDamages',
                route: this.$route.path
              }

              const tags = prepareErrorForSentry(error, context)

              this.sendSentryError(
                `Error patching damage: ${error.message || 'Unknown error'}`,
                error.response && error.response.status >= 500 ? 'error' : 'warning',
                tags,
                this.getSinisterId,
                'handleAddDamages'
              )

              setTimeout(() => {
                this.error = false
              }, 2000)
            })
        })
      } else {
        this.loading = false
        window.scrollTo(0, 0)
        this.throwNotification(
          this.$t('claim.details.errorImages'),
          this.$t('claim.details.errorImages'),
          'KO'
        )
      }
    },

    /**
     * Damage is updated locally on input change.
     */
    handleFormChange: function (event) {
      if (event.inpTextNumbers) {
        const inputValParsed = event.inputVal.replace(',', '.')
        this.damage[event.inputId] = inputValParsed
      } else {
        this.damage[event.inputId] = event.inputVal
      }
      this.handleEnableButton()
    },

    /**
     * Debounced function (Important. Just first input event is catched). Form has to be updated always because rep_type_code changes depending on input value combination.
     */
    handleNestedComponents: debounce(function (event) {
      this.activeInputValue = event.inputVal
      this.updateForm()
    }, 250),

    filterForms(data) {
      this.formData = data
      Object.keys(this.stateWarrantyCategoriesMobilier).forEach((key) => {
        this.formData.form.regions[0].inputs =
          this.formData.form.regions[0].inputs.filter((input) => {
            return input.name !== key
          })
      })
      this.formData.form.regions[0].inputs =
        this.formDataform.form.regions[0].inputs.filter((input) => {
          return input.type !== 'hidden'
        })
      this.setDefaultValuesForm()
      this.$nextTick(() => {
        this.handleUpdateForm()
      })
    },
    updateForm: function () {
      const report = { ...this.damage }
      const formInputs = document.querySelectorAll('.warranty__content input')

      delete report['asset_damages']

      formInputs.forEach(function (el) {
        el.disabled = true
      })
      return apiGetForm(report, this.getWarrantyId)
        .then((data) => {
          this.formData = null
          this.$nextTick(() => {
            this.filterForms(data)
          })
        })
        .catch((error) => {
          const context = {
            component: 'damageMobilierCategory1',
            method: 'updateForm',
            route: this.$route.path
          }

          const tags = prepareErrorForSentry(error, context)

          this.sendSentryError(
            `Error updating form: ${error.message || 'Unknown error'}`,
            error.response && error.response.status >= 500 ? 'error' : 'warning',
            tags,
            this.getWarrantyId,
            'updateForm'
          )

          return Promise.reject(error)
        })
        .finally(() => {
          formInputs.forEach(function (el) {
            el.disabled = false
          })
        })
    },

    /**
     * Sets the focus/blur for the active input
     */
    handleUpdateForm: function () {
      if (this.activeInput !== '') {
        const activeInputType = this.activeInput.getAttribute('type')
        const activeInputName = this.activeInput.getAttribute('name')
        const activeInputVal = this.activeInputValue
        // REFACTOR MOVER A FORM
        if (
          activeInputType === 'checkbox' &&
          this.activeInput.hasAttribute('isSelect')
        ) {
          document.querySelector('input[name=' + activeInputName + ']').focus()
          document.querySelector('input[name=' + activeInputName + ']').blur()
        } else if (activeInputType === 'text') {
          document.querySelector('input[name=' + activeInputName + ']').focus()
        } else {
          const el = document.querySelector(
            'input[value="' + activeInputVal + '"]'
          )
          if (el) el.focus()
        }
      }
    },

    /**
     * Sets the defauld values for each form when is updated - the input.selected values that come from the forms api
     */
    setDefaultValuesForm: function () {
      this.damage = {}
      this.damage.asset_damages = this.formData.form.asset_damages || ''

      this.formData.form.regions.forEach((region) => {
        region.inputs.forEach((input) => {
          if (input.selectedValue) {
            this.damage[input.name] = input.selectedValue
          }
        })
      })
    },

    /**
     * Sets the defauld values for each form when the view is printed - the input.selected values that come from the forms api
     */
    setDefaultValues: function () {
      this.damage = {}
      this.damage.asset_damages = this.formData.form.asset_damages || ''
      this.damage = { ...this.stateWarrantyCategoriesMobilier }
      this.formData.form.regions.forEach((region) => {
        region.inputs.forEach((input) => {
          if (input.selectedValue) {
            this.damage[input.name] = input.selectedValue
          }
        })
      })
    },

    /**
     * Adds levels to the levels object
     */
    addLevels() {
      Object.keys(this.stateWarrantyCategoriesMobilier).forEach((key) => {
        // add levels
        this.formTemplate.form.regions[0].inputs.forEach((input) => {
          if (input.name === key && input.name !== 'ASSETS') {
            if (!this.levels.level1) {
              this.levels['level1'] = input.id
            } else if (
              !this.levels.level2 &&
              this.levels.level1.id !== input.id &&
              this.levels.level1 !== input.id
            ) {
              this.levels['level2'] = input.id
            }
          }
        })
      })
    },

    /**
     * Updates the state report, calls action actWarrantyGetForms to get the froms and sets the data for the forms, sets the default value inputs for the form
     */
    getForm() {
      if (
        this.stateWarrantyForms.length > 0 &&
        this.stateWarrantyCategoriesQty === 1
      ) {
        this.formTemplate = this.stateWarrantyForms[0]
        this.filterForm()
      } else {
        this.mutWarrantyClearForms()
        let report = this.stateWarrantyCategoriesMobilier
        const warrantyId = this.getWarrantyId
        this.actWarrantyGetForms({ report, warrantyId }).then((res) => {
          if (res.formsUpdated) {
            this.formTemplate = Object.assign(this.stateWarrantyForms[0], {})
            this.filterForm()
          }
        }).catch((error) => {
          const context = {
            component: 'damageMobilierCategory1',
            method: 'getForm',
            route: this.$route.path
          }

          const tags = prepareErrorForSentry(error, context)

          this.sendSentryError(
            `Error getting form data: ${error.message || 'Unknown error'}`,
            error.response && error.response.status >= 500 ? 'error' : 'warning',
            tags,
            this.getWarrantyId,
            'getForm'
          )
        })
      }
      this.handleEnableButton()
    },

    /**
     * Filters the form of hidden inputs and categories selected in previous views
     */
    filterForm() {
      // if the form has more categories remove the ones selected before and print the first input
      if (
        this.stateWarrantyCategoriesQty !== 0 ||
        this.stateWarrantyCategoryFinalLevel === false
      ) {
        // add levels
        this.addLevels()
        // remove categories selected before
        Object.keys(this.stateWarrantyCategoriesMobilier).forEach((key) => {
          this.formTemplate.form.regions[0].inputs =
            this.formTemplate.form.regions[0].inputs.filter((input) => {
              return input.name !== key
            })
        })
        // remove hidden inputs
        this.formTemplate.form.regions[0].inputs =
          this.formTemplate.form.regions[0].inputs.filter((input) => {
            return input.type !== 'hidden'
          })
        this.formType = 'titlesList'
        this.formData = this.formTemplate.form.regions[0].inputs[0]
      } else {
        this.setFormType()
        // print the data form
        Object.keys(this.stateWarrantyCategoriesMobilier).forEach((key) => {
          this.formTemplate.form.regions[0].inputs =
            this.formTemplate.form.regions[0].inputs.filter((input) => {
              return input.name !== key
            })
        })
        this.formTemplate.form.regions[0].inputs =
          this.formTemplate.form.regions[0].inputs.filter((input) => {
            return input.type !== 'hidden'
          })
        this.formData = this.formTemplate

        const sinisterId = this.getSinisterId
        if (!this.stateWarrantySinisterId) {
          this.actWarrantyGetSinister(sinisterId)
        }
        this.setDefaultValues()
        this.setWatchers()
      }
    },

    /**
     * Gets the target uptec option(subcategory) that was last selected, stateWarrantyCategoriesMobilier has all the selected categories selected from a product, and damagedItemKey is the key of the last selected category
     */
    getTargetUptecItem() {
      if (this.stateWarrantyCategoriesMobilier) {
        return this.stateWarrantyCategoriesMobilier[
          this.stateWarrantyDamagedItemKey
        ].toUpperCase()
      }
    },

    /**
     * Sets the form type, if the option is uptec damage and its type is cpi, it will get the targetUptecItem which is the last selected category to get the correct product id for this option, else if it's an uptec damage and the type is feature it will only set the form type and get the product id as there will be only one result for it, else it's the formInputsMobilier, the general form with its corresponding inputs
     */
    setFormType() {
      const formInput = this.formTemplate.form.regions[0].inputs.find(
        (input) => input.name === this.stateWarrantyDamagedItemKey
      )
      const formInputOption = formInput.options.find(
        (option) => option.key.toUpperCase() === this.getTargetUptecItem()
      )

      if (formInputOption.is_upptec_damage === false) {
        this.formType = FORM_INPUTS_MOBILIER
      } else if (formInputOption.upptec_damage_type === FEATURE) {
        this.formType = FORM_UPTEC_FEATURE
        this.poductIdGroup = formInputOption.upptec_productIdGroup
      } else if (formInputOption.upptec_damage_type === CPI) {
        this.formType = FORM_UPTEC_CPI
        this.poductIdGroup = formInputOption.upptec_product_group_id
      }
    },

    setWatchers: function () {
      let vm = this
      vm.$watch('getWarrantyId', function () {
        this.updateForm()
        this.clearForm()
      })
    },

    /**
     * Sets title category
     */
    setTitleCategory() {
      const lastLiteral =
        Object.values(this.stateWarrantyLiteralsMobilier).length - 1
      this.titleCategory = Object.values(this.stateWarrantyLiteralsMobilier)[
        lastLiteral
      ]
    },

    /**
     * Sets the focus when an input is modified
     */
    handleInputFocus: function () {
      const focusedInput = document.querySelector('input:focus')
      if (document.querySelector('input:focus') !== null) {
        this.activeInput = focusedInput
      }
    },

    /**
     * Gets the warranty id from local storage if it doesen't exist
     */
    getSubwarrantyId() {
      if (!this.stateWarrantySubtypeId) {
        this.warrantySubtypeId = localStorage.getItem('warranty_subtype_id')
      }
    },

    /**
     * Pushes the image in the imgListEnsemble array
     */
    /* handleImgChangeEnsemble(event) {
      const dataImg = event.fileData ? event.fileData : event
      this.imgListEnsemble.push(dataImg)
    }, */

    /**
     * Pushes the image in the imgListPres array
     */
    handleImgChangePres(event) {
      const dataImg = event.fileData ? event.fileData : event
      this.imgListPres.push(dataImg)
      this.handleEnableButton()
    },
    getUptecObj() {
      let key = 'titleCat'
      let value = this.titleCategory
      this.mutWarrantyUpdateObjUptec({ key, value })
      value = this.titleCategory
      this.mutWarrantyUpdateObjUptec({ key, value })
      key = 'cat2'
      value = this.stateWarrantyLiteralsMobilier.cat2
      this.mutWarrantyUpdateObjUptec({ key, value })
      key = 'cat1'
      value = this.stateWarrantyLiteralsMobilier.cat1
      this.mutWarrantyUpdateObjUptec({ key, value })
    },

    handleBackButtonClick() {
      window.removeEventListener('popstate', this.handleBackButtonClick)
      this.goToView('damageMobilier')
    },

    /**
     * Adds the damage for the cpi uptec mobilier
     */
    async handleAddDamagesCpi() {
      this.loading = true
      let imgList = []
      this.getUptecObj()
      this.filterImageSrc()
      this.getSubwarrantyId()
      imgList = [
        ...imgList /* ...this.imgListEnsemble */,
        ...this.imgListPres
      ]

      const imagesValidated = await this.checkImages(imgList)
      if (imagesValidated) {
        if (this.poductIdGroup && this.inputValDate && this.inputValPrice) {
          const objDamage = {
            sinister_id: this.getSinisterId,
            product_group_id: this.poductIdGroup,
            upptec_damage_type: CPI,
            date_of_purchase: this.inputValDate,
            purchase_price: this.inputValPrice,
            images: imgList
          }
          this.$refs.modalConfirmation.showModal = false
          apiPostDamageUptec(objDamage)
            .then((res) => {
              let key = 'date'
              let value = res.date_of_purchase
              this.mutWarrantyUpdateObjUptec({ key, value })
              key = 'price'
              value = res.purchase_price.amount
              this.mutWarrantyUpdateObjUptec({ key, value })
              const depreciation = res.calculation_details.depreciation * 100
              key = 'depreciation'
              value = Math.trunc(depreciation)
              this.mutWarrantyUpdateObjUptec({ key, value })
              key = 'indemnisation'
              value = res.calculation_details.compensation.amount
              this.mutWarrantyUpdateObjUptec({ key, value })
              key = 'totalPayment'
              value = res.calculation_details.current_market_price.amount
              this.mutWarrantyUpdateObjUptec({ key, value })
              key = 'images'
              value = res.images
              this.mutWarrantyUpdateObjUptec({ key, value })

              this.mutWarrantyClearForms()
              this.mutWarrantyClearReport()
              const damageResultUptecViewName = 'damage-result-uptec'
              this.goToView(damageResultUptecViewName)
            })
            .catch((error) => {
              this.loading = false
              this.error = true
              this.errorMsg = this.$t(
                `notifications.error.${error.response.status}.title`
              )

              const context = {
                component: 'damageMobilierCategory1',
                method: 'handleAddDamagesCpi',
                route: this.$route.path
              }

              const tags = prepareErrorForSentry(error, context)

              this.sendSentryError(
                `Error posting Uptec damage: ${error.message || 'Unknown error'}`,
                error.response && error.response.status >= 500 ? 'error' : 'warning',
                tags,
                this.getSinisterId,
                'handleAddDamagesCpi'
              )

              setTimeout(() => {
                this.error = false
              }, 2000)
            })
        } else {
          this.loading = false
          this.error = true
          this.errorMsg = this.$t(`notifications.error.${400}.title`)
          setTimeout(() => {
            this.error = false
          }, 2000)
        }
      } else {
        this.loading = false
        this.$refs.modalConfirmation.showModal = false
        this.throwNotification(
          this.$t('claim.details.errorImages'),
          this.$t('claim.details.errorImages'),
          'KO'
        )
      }
    }
  },
  watch: {
    inputValPrice(value) {
      if (value.length >= 1) this.checkInputPriceFormat(value)
    }
  },

  /**
   * Sets the title category and gets form
   */
  mounted() {
    window.addEventListener('popstate', this.handleBackButtonClick)
    this.setTitleCategory()
    this.getForm()

    maEventBus.$on('inputWarranty:focus', ($event) =>
      this.handleInputFocus($event)
    )
  }
}
